import { Actions, ActionTypes, FetchDiscounts, FetchDiscountsReason } from './actions';
import { Campaign, Discount } from '../../types/discounts';
import { paramsEqual } from '../../helpers/urlParams';

export interface State {
    isLoading: boolean;
    error: boolean;
    discounts: Discount[];
    hasNext: boolean;
    isLoadingNext: boolean;
    params: URLSearchParams;
    accountId: string;
    campaigns: Campaign[];
}

export const initialState: State = {
    isLoading: false,
    error: false,
    discounts: [],
    hasNext: true,
    isLoadingNext: false,
    params: new URLSearchParams(),
    accountId: '',
    campaigns: [],
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.FetchDiscounts:
            const clearList = shouldClearList(action, state);
            return {
                ...state,
                isLoading: true,
                isLoadingNext: true,
                params: action.payload.params,
                accountId: action.payload.accountId,
                discounts: clearList ? [] : state.discounts,
            };

        case ActionTypes.FetchCampaignsResponse:
            return {
                ...state,
                campaigns: action.payload.campaigns,
            };

        case ActionTypes.FetchDiscountsResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
                discounts: [...state.discounts, ...action.payload.discounts],
            };

        case ActionTypes.FetchNextDiscountResponse:
            return {
                ...state,
                isLoading: false,
                hasNext: action.payload.discounts.length > 0,
                isLoadingNext: false,
            };

        default:
            return state;
    }
}

const shouldClearList = (action: FetchDiscounts, state: State) => {
    if (action.payload.accountId !== state.accountId) {
        return true;
    }
    if (
        action.payload.reason === FetchDiscountsReason.mount ||
        action.payload.reason === FetchDiscountsReason.refresh
    ) {
        return true;
    }
    const blacklist = ['starting_after', 'limit'];
    return !paramsEqual(action.payload.params, state.params, blacklist);
};
